// Types
import { blue, grey } from '../../../common/styles/colours';
export var NavigationCardPropertiesByVariant = {
    default: function (theme) {
        var _a, _b, _c;
        return ({
            hoverLeftIconColor: (_a = theme.hoverAccent) !== null && _a !== void 0 ? _a : blue[700],
            activeLeftIconColor: (_b = theme.clickedAccent) !== null && _b !== void 0 ? _b : blue[800],
            activeBorderColor: (_c = theme.borderPrimary) !== null && _c !== void 0 ? _c : grey[300],
        });
    },
};
//# sourceMappingURL=NavigationCardPropertiesByVariant.js.map